class MonsgaProductSubnav extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.links = [...this.querySelectorAll('[data-product-subnav-link]')];
    this.targets = this.links
      .map((link) => {
        const hash = link.getAttribute('href');
        return hash && hash.startsWith('#') ? document.getElementById(hash.slice(1)) : null;
      })
      .filter(Boolean);
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onHashChange = this.onHashChange.bind(this);
    this.onClick = this.onClick.bind(this);

    this.links.forEach((link) => link.addEventListener('click', this.onClick));
    window.addEventListener('resize', this.onResize, { passive: true });
    window.addEventListener('hashchange', this.onHashChange);
    this.disableSmoothScrolling();
    this.onResize();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    document.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('hashchange', this.onHashChange);
    this.links?.forEach((link) => link.removeEventListener('click', this.onClick));
    this.scrollRoots?.forEach((root) => root.removeEventListener('scroll', this.onScroll));
    this.observer?.disconnect();
    if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);
  }

  disableSmoothScrolling() {
    [document.documentElement, document.body, document.querySelector('.page-wrapper')]
      .filter(Boolean)
      .forEach((element) => element.style.setProperty('scroll-behavior', 'auto', 'important'));
  }

  onResize() {
    const header = document.querySelector('#header-component');
    const headerRect = header?.getBoundingClientRect();
    const headerIsHidden = header?.dataset.stickyState === 'idle';
    const headerHeight = headerRect && !headerIsHidden ? Math.max(0, Math.min(headerRect.height, headerRect.bottom)) : 0;
    const sectionWrapper = this.closest('.shopify-section') || this.parentElement;
    sectionWrapper?.style.setProperty('--monsga-product-subnav-header-offset', `${Math.round(headerHeight)}px`);
    this.scrollOffset = Math.ceil(headerHeight + this.getBoundingClientRect().height + 16);
    this.targets.forEach((target) => target.style.setProperty('scroll-margin-block-start', `${this.scrollOffset}px`));
    this.scrollRoots?.forEach((root) => root.removeEventListener('scroll', this.onScroll));
    this.scrollRoots = [window, document, document.querySelector('.page-wrapper')]
      .filter(Boolean)
      .filter((root, index, roots) => roots.indexOf(root) === index);
    this.scrollRoots.forEach((root) => root.addEventListener('scroll', this.onScroll, { passive: true }));
    this.observer?.disconnect();
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(() => this.onScroll(), {
        root: null,
        rootMargin: `-${this.scrollOffset}px 0px -55% 0px`,
        threshold: [0, 0.01, 0.25]
      });
      this.targets.forEach((target) => this.observer.observe(target));
    }
    this.onScroll();
  }

  onClick(event) {
    const link = event.currentTarget;
    const hash = link?.getAttribute('href');
    if (hash?.startsWith('#')) this.setActive(hash);
  }

  onHashChange() {
    if (location.hash) this.setActive(location.hash);
  }

  onScroll() {
    if (this.scrollFrame) return;
    this.scrollFrame = window.requestAnimationFrame(() => {
      this.scrollFrame = null;
      // Keep the active tab aligned with the section currently occupying the reading area,
      // not only with the first pixel below the sticky header.
      const marker = Math.max((this.scrollOffset || this.offsetHeight) + 8, Math.round(window.innerHeight * 0.3));
      let activeTarget = this.targets[0];
      this.targets.forEach((target) => {
        if (target.getBoundingClientRect().top <= marker) activeTarget = target;
      });
      if (activeTarget) this.setActive(`#${activeTarget.id}`);
    });
  }

  setActive(hash) {
    this.links.forEach((link) => link.setAttribute('aria-current', String(link.getAttribute('href') === hash)));
  }
}

if (!customElements.get('monsga-product-subnav')) {
  customElements.define('monsga-product-subnav', MonsgaProductSubnav);
}
